/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateQuestionsControllerFindAllQueryResponse, TemplateQuestionsControllerFindAllQueryParams, TemplateQuestionsControllerFindAll401, TemplateQuestionsControllerFindAll403 } from "../../models/checklistsController/TemplateQuestionsControllerFindAll";

function getTemplateQuestionsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/checklist-template-questions` as const }  
  return res
}

/**
 * @description This endpoint supports a higher page size limit of 1000 (default is 100). Use `page[size]=1000` to retrieve up to 1000 records per request.
 * @summary Get all checklist template questions
 * {@link /api/v1/checklist-template-questions}
 */
export async function templateQuestionsControllerFindAll(params?: TemplateQuestionsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplateQuestionsControllerFindAllQueryResponse, ResponseErrorConfig<TemplateQuestionsControllerFindAll401 | TemplateQuestionsControllerFindAll403>, unknown>({ method : "GET", url : getTemplateQuestionsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}